import { render, staticRenderFns } from "./RecommendationSubjectDetail.vue?vue&type=template&id=582c56a9&scoped=true&"
import script from "./RecommendationSubjectDetail.vue?vue&type=script&lang=js&"
export * from "./RecommendationSubjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c56a9",
  null
  
)

export default component.exports